export const environment = {
  production: false,
  /** Proxy local → Google Apps Script (ver proxy.conf.json) */
  apiUrl: '/api',
  /** Si la API falla, usa employees.json (útil sin Sheet configurado) */
  fallbackToLocalData: true,
  /** Base para imágenes en firma copiada (vacío = origen actual) */
  assetBaseUrl: ''
};
